import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import ATMFilePickerWrapper from "src/components/UI/atoms/formFields/ATMFileUploader/ATMFileUploaderWrapper";
import { ResourceFormValues } from "src/models/Resource.model";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";

type Props = {
  formikProps: FormikProps<ResourceFormValues>;
  onClose: () => void;
  formType: "ADD" | "UPDATE";
};

const resourceTypeData = [
  {
    label: "IMAGE",
    value: "IMAGE",
  },
  {
    label: "DATA",
    value: "DATA",
  },
];

const ResourceForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add Resource" : "Update Resource"}{" "}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        {/* Resource Type */}
        <div className="">
          <ATMSelect
            name="resourceType"
            value={values.resourceType}
            onChange={(newValue) => setFieldValue("resourceType", newValue)}
            onBlur={handleBlur}
            label="Resource Type"
            placeholder="Select Resource Type"
            options={resourceTypeData}
          />
        </div>
        <div>
          <ATMTextField
            placeholder="Enter Title"
            name="title"
            required
            value={values?.title}
            onChange={(e) => {
              setFieldValue("title", e.target.value);
            }}
            label="Title"
            onBlur={handleBlur}
          />
        </div>
        {values?.resourceType?.value === "IMAGE" && (
          <div className="mt-4">
            <ATMFilePickerWrapper
              name="imageUrl"
              label="File"
              placeholder="select file"
              selectedFile={values?.imageUrl}
              onSelect={(imgUrl) => {
                setFieldValue("imageUrl", imgUrl);
              }}
            />
          </div>
        )}
        {values?.resourceType?.value === "DATA" && (
          <ATMTextArea
            placeholder="Enter Description"
            name="dataDescription"
            label="Data "
            required
            value={values?.dataDescription}
            onChange={(newValue) => {
              setFieldValue("dataDescription", newValue);
            }}
          />
        )}
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default ResourceForm;
